import { render, staticRenderFns } from "./cta.vue?vue&type=template&id=f06045f0"
import script from "./cta.vue?vue&type=script&lang=js"
export * from "./cta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports